import React, { useEffect } from "react"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { getIngredientDetails } from "store/actions/ingredientAction"
import formatDateTime from "components/Shared/formatDateTime"
import placeholderImage from "assets/images/placeholderImage.png"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import { formatImageTypeLabel } from "utils/displayLabels"

const IngredientDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Ingredient Details `)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      23,
      "ingredient_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  const { loading, ingredientDetails } = useSelector(state => state.Ingredients)
  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getIngredientDetails(payload))
  }
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={8}>
            <Card className="card_100_24">
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Ingredient Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={340} rounded />
                  ) : Object.values(ingredientDetails).length === 0 ? (
                    <p className="text-center my-3">
                      {t("No ingredient details found")}
                    </p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{ingredientDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(English)")} </th>
                          <td>{ingredientDetails?.name}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Name(عربي)")}</th>
                          <td>{ingredientDetails?.nameAr}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Price")}</th>
                          <td>{ingredientDetails.price ?? "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Display Order")}</th>
                          <td>{ingredientDetails.displayOrder || "-"}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Image Type")}</th>
                          <td>
                            {formatImageTypeLabel(ingredientDetails.imageUrlType)}
                          </td>
                        </tr>

                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {ingredientDetails?.status === 1 ? (
                              <Badge className="bg-success">
                                {t("Active")}
                              </Badge>
                            ) : (
                              <Badge className="bg-danger">
                                {t("Deactive")}
                              </Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Created At")}</th>
                          <td>
                            {formatDateTime(ingredientDetails.createdAt) || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Updated At")}</th>
                          <td>
                            {formatDateTime(ingredientDetails.updatedAt) || "-"}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="card_100_24">
              <CardBody>
                {loading ? (
                  <div className="pt-5">
                    <ShimmerThumbnail height={340} rounded />
                  </div>
                ) : Object.values(ingredientDetails).length === 0 ? (
                  <p className="text-center my-3">{t("No ingredient details found")}</p>
                ) : (
                  <div className="g_center h-100">
                    <img
                      src={
                        ingredientDetails.imageUrl
                          ? ingredientDetails.imageUrl
                          : placeholderImage
                      }
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default IngredientDetails
